const isFooterVisible = () => {
  const footer = document.querySelector('footer');
  if (!footer) return false;

  const rect = footer.getBoundingClientRect();
  return (
    rect.top < window.innerHeight &&
    rect.bottom >= 0
  );
};

window.addEventListener('scroll', () => {
  if (isFooterVisible()) {
    document.querySelector('.wens-haelo-audio-player-wrapper.true').style.display = 'none';
  } else {
    document.querySelector('.wens-haelo-audio-player-wrapper.true').style.display = 'block';
  }
});

document.addEventListener('DOMContentLoaded', function () {

  class AudioPlayer {
    constructor(playerElement) {
      this.player = playerElement;
      this.playlist = JSON.parse(this.player.dataset.playlist);
      this.currentIndex = 0;
      this.isPlaying = false;
      this.isLooping = false;
      this.isShuffling = false;
      this.color = this.player.getAttribute("data-color") || "#defaultColor";
      this.isPlaylistVisible = false;

      this.audio = this.player.querySelector('.wens-haelo-audio');
      this.playButton = this.player.querySelector('.wens-haelo-play-button');
      this.prevButton = this.player.querySelector('.wens-haelo-prev-button');
      this.nextButton = this.player.querySelector('.wens-haelo-next-button');
      this.seekBar = this.player.querySelector('.wens-haelo-seek-bar');
      this.muteButton = this.player.querySelector('.wens-haelo-mute-button');

      this.volumeSlider = this.player.querySelector('.wens-haelo-volume-slider');
      this.shuffleButton = this.player.querySelector('.wens-haelo-shuffle-button');
      this.loopButton = this.player.querySelector('.wens-haelo-loop-button');
      this.playlistButton = this.player.querySelector('.wens-haelo-play-list-icon');

      // The wrapper that uniquely identifies THIS player instance.
      // Every lookup for playlist / design-type below is scoped to this wrapper
      // so multiple players on the same page never cross-talk.
      this.wrapper = this.player.closest('.wens-haelo-audio-player-wrapper');

      this.designType = this.wrapper.classList.contains('designtwo')
        ? 'designtwo'
        : (this.wrapper.classList.contains('designthree')
          ? 'designthree'
          : 'designone');

      this.trackTitle = this.player.querySelector('.wens-haelo-track-title');
      this.trackImage = this.player.querySelector('.wens-haelo-audio-track-image');
      this.timeInfo = this.player.querySelector('.wens-haelo-audio-time-info span');

      // FIX: always resolve the playlist container relative to THIS player's
      // own wrapper, regardless of design type. Previously "designone" fell
      // back to document.querySelector('.wens-haelo-play-list'), which always
      // grabbed the FIRST playlist element in the whole page — causing every
      // designone instance (e.g. the sticky/footer player) to open the same
      // (wrong) playlist instead of its own.
      this.playlistContainer = this.wrapper.querySelector('.wens-haelo-play-list');

      this.initializePlayer();
      this.attachEventListeners();
      this.applyPlaylistStyles();
      this.initializePlaylistListeners();
    }

    applyPlaylistStyles() {
      if (this.playlistContainer) {
        const trackItems = this.playlistContainer.querySelectorAll('.wens-haelo-play-list-item');
        trackItems.forEach((item, i) => {
          item.classList.remove('odd', 'even', 'playing');

          if (i % 2 === 0) {
            item.classList.add('even');
          } else {
            item.classList.add('odd');
          }

          if (i === this.currentIndex) {
            item.classList.add('playing');
          }
        });
      }
    }

    initializePlaylistListeners() {
      if (this.playlistContainer) {
        const items = this.playlistContainer.querySelectorAll('.wens-haelo-play-list-item');

        items.forEach(item => {
          item.addEventListener('click', (e) => {
            let trackChanged = this.handleTrackClick(item);
            if (trackChanged !== false) {
              this.playlistContainer.classList.remove('playlist-active');
            }
          });
        });
      }
    }

    handleTrackClick(item) {
      const index = parseInt(item.dataset.index);
      this.loadTrack(index);
      this.audio.play();
      this.isPlaying = true;
      this.playButton.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 4H10V20H6V4Z" stroke=${this.color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14 4H18V20H14V4Z" stroke=${this.color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>`;
      this.applyPlaylistStyles();
    }

    togglePlaylist() {
      const index = this.currentIndex;
      const trackItems = this.playlistContainer.querySelectorAll('.wens-haelo-play-list-item');

      trackItems.forEach((item, i) => {
        item.classList.remove('playing', 'odd', 'even');

        if (i % 2 === 0) {
          item.classList.add('even');
        } else {
          item.classList.add('odd');
        }
      });

      const currentTrack = this.playlistContainer.querySelectorAll('.wens-haelo-play-list-item')[index];
      this.playlistContainer.querySelectorAll('.wens-haelo-play-list-item').forEach(item => {
        item.classList.remove('playing');
      });
      if (currentTrack) {
        currentTrack.classList.add('playing');
      }

      if (this.playlistContainer) {
        this.isPlaylistVisible = !this.isPlaylistVisible;
        this.playlistContainer.style.opacity = this.isPlaylistVisible ? '1' : '0';
        if (this.isPlaylistVisible) {
          this.playlistContainer.classList.add('playlist-active');
        } else {
          this.playlistContainer.classList.remove('playlist-active');
        }
      }
    }

    initializePlayer() {
      if (this.playlist.length > 0) {
        this.loadTrack(0);
      }
    }

    loadTrack(index) {
      this.currentIndex = index;
      const track = this.playlist[index];
      this.audio.src = track.url;
      // this.trackTitle.textContent = track.title;
      this.trackImage.src = track.image;
      if (this.isPlaying) {
        this.audio.play();
      }
    }

    togglePlay() {
      if (this.audio.paused) {
        this.audio.play();
        this.isPlaying = true;
        this.playButton.innerHTML = `
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 4H10V20H6V4Z" stroke=` + this.color + ` stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M14 4H18V20H14V4Z" stroke=` + this.color + ` stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>`;
      } else {
        this.audio.pause();
        this.isPlaying = false;
        this.playButton.innerHTML = `
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 3L19 12L5 21V3Z" stroke=` + this.color + ` stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>`;
      }
    }

    updateSeekBar() {
      if (this.audio.duration) {
        this.seekBar.value = (this.audio.currentTime / this.audio.duration) * 100;
        this.seekBar.style.background = `linear-gradient(to right, ${this.color} ${this.seekBar.value}%, #ccc ${this.seekBar.value}%)`;
      }
    }

    playNext() {
      let nextIndex;
      if (this.isShuffling) {
        nextIndex = Math.floor(Math.random() * this.playlist.length);
      } else {
        nextIndex = (this.currentIndex + 1) % this.playlist.length;
      }
      this.loadTrack(nextIndex);
    }

    playPrevious() {
      let prevIndex = this.currentIndex === 0 ? this.playlist.length - 1 : this.currentIndex - 1;
      this.loadTrack(prevIndex);
    }

    updateTimeInfo() {
      const currentTime = this.formatTime(this.audio.currentTime);
      const duration = this.formatTime(this.audio.duration || 0);

      this.timeInfo.textContent = `${currentTime} / ${duration}`;

      if (this.audio.duration) {
        this.seekBar.value = (this.audio.currentTime / this.audio.duration) * 100 || 0;
      }
    }

    formatTime(time) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }

    attachEventListeners() {

      this.playButton.addEventListener('click', () => this.togglePlay());
      this.prevButton.addEventListener('click', () => this.playPrevious());
      this.nextButton.addEventListener('click', () => this.playNext());
      this.audio.addEventListener('timeupdate', () => this.updateSeekBar());
      this.audio.addEventListener('timeupdate', () => this.updateTimeInfo());
      this.audio.addEventListener('ended', () => this.playNext());

      // Add/remove a "playing" class on this player (and its wrapper) whenever
      // playback actually starts/stops. Hooking the audio element's native
      // play/pause events (instead of only togglePlay()) means the class stays
      // correct no matter what triggered playback — the play button, a
      // playlist item click, autoplay after loadTrack(), or playNext()/ended.
      this.audio.addEventListener('play', () => {
        this.player.classList.add('wens-haelo-playing');
        this.wrapper.classList.add('wens-haelo-playing');
      });

      this.audio.addEventListener('pause', () => {
        this.player.classList.remove('wens-haelo-playing');
        this.wrapper.classList.remove('wens-haelo-playing');
      });

      this.seekBar.addEventListener('input', (e) => {
        const time = (e.target.value / 100) * this.audio.duration;
        this.audio.currentTime = time;
      });

      this.muteButton.addEventListener('click', () => {
        this.audio.muted = !this.audio.muted;
        const volumeIcon = this.muteButton.querySelector('svg');

        if (this.audio.muted) {
          volumeIcon.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="${this.color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-volume-x">
              <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"/>
              <line x1="22" x2="16" y1="9" y2="15"/>
              <line x1="16" x2="22" y1="9" y2="15"/>
            </svg>
          `;
        } else {
          volumeIcon.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="${this.color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-volume-2">
              <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"/>
              <path d="M16 9a5 5 0 0 1 0 6"/>
              <path d="M19.364 18.364a9 9 0 0 0 0-12.728"/>
            </svg>
          `;
        }
      });

      this.shuffleButton.addEventListener('click', () => {
        this.isShuffling = !this.isShuffling;
        this.shuffleButton.querySelector('svg').style.fill = this.isShuffling ? this.color : 'gray';
      });

      this.loopButton.addEventListener('click', () => {
        if (!this.audio) return;

        this.isLooping = !this.isLooping;
        this.audio.loop = this.isLooping;

        const svgElement = this.loopButton.querySelector('svg');

        if (svgElement) {
          svgElement.style.stroke = this.isLooping ? this.color : this.color;

          let textElement = svgElement.querySelector('text');

          if (!textElement) {
            textElement = document.createElementNS("http://www.w3.org/2000/svg", "text");
            textElement.setAttribute("x", "12");
            textElement.setAttribute("y", "12");
            textElement.setAttribute("font-size", "6");
            textElement.setAttribute("text-anchor", "middle");
            textElement.setAttribute("fill", this.color);
            textElement.setAttribute("dy", ".3em");
            textElement.textContent = '1';

            svgElement.appendChild(textElement);
          } else {
            textElement.textContent = this.isLooping ? '1' : '';
          }
        }
      });

      if (this.playlistButton && this.playlistContainer) {
        this.playlistButton.addEventListener('click', () => {
          this.togglePlaylist();
        });

        // NOTE: these click handlers are attached to items inside
        // this.playlistContainer, which is now correctly scoped to THIS
        // player's own wrapper — so clicks here only ever affect this player.
        this.playlistContainer.querySelectorAll('.wens-haelo-play-list-item').forEach(item => {
          item.addEventListener('click', () => {
            const index = parseInt(item.dataset.index);

            this.loadTrack(index);

            if (this.isPlaying) {
              this.audio.play();
            } else {
              this.togglePlay();
            }

            this.playlistContainer.querySelectorAll('.wens-haelo-play-list-item').forEach(listItem => {
              listItem.classList.remove('playing');
              listItem.querySelector('svg')?.remove();
            });

            item.classList.add('playing');
          });
        });
      }

      if (this.volumeSlider && this.designType !== 'designthree') {
        this.volumeSlider.addEventListener('change', (e) => {
          const volume = e.target.value;
          this.audio.volume = volume;

          const volumeIcon = this.muteButton.querySelector('svg');
          if (volume == 0) {
            volumeIcon.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke=${this.color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-volume-x">
                <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"/>
                <line x1="22" x2="16" y1="9" y2="15"/>
                <line x1="16" x2="22" y1="9" y2="15"/>
              </svg>
            `;
          } else if (volume <= 0.5) {
            volumeIcon.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke=${this.color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-volume-1">
                <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"/>
              </svg>
            `;
          } else {
            volumeIcon.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke=${this.color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-volume-2">
                <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"/>
              </svg>
            `;
          }
        });
      }

    }
  }

  document.querySelectorAll('.wens-haelo-audio-player').forEach(playerElement => {
    new AudioPlayer(playerElement);
  });

  const volumeSlider = document.querySelector(".wens-haelo-volume-slider");
  if (volumeSlider) {
    const sliderVolumeColor = volumeSlider.getAttribute("data-color") || "#ff5733";
    volumeSlider.addEventListener("input", function () {
      const percentage = (this.value / this.max) * 100;
      this.style.background = `linear-gradient(to right, ${sliderVolumeColor} ${percentage}%, #ccc ${percentage}%)`;
    });
  }

  const playerSlider = document.querySelector(".wens-haelo-seek-bar");
  if (playerSlider) {
    const sliderColor = playerSlider.getAttribute("data-color") || "#ff5733";
    playerSlider.addEventListener("input", function () {
      const percentage = (this.value / this.max) * 100;
      this.style.background = `linear-gradient(to right, ${sliderColor} ${percentage}%, #ccc ${percentage}%)`;
    });
  }

  let playlists = document.querySelectorAll(".wens-haelo-playlist");

  playlists.forEach((playlist) => {
    let audio = playlist.querySelector(".wens-haelo-audio");
    let titleElement = playlist.querySelector(".wens-haelo-track-title");
    let nextButton = playlist.querySelector(".wens-haelo-next-button");

    function updateTitle() {
      let src = audio.getAttribute("src");
      if (src) {
        let filename = src.split("/").pop().split(".")[0];
        titleElement.textContent = filename.replace(/[-_]/g, " ");
      }
    }

    audio.addEventListener("loadedmetadata", updateTitle);

    nextButton?.addEventListener("click", function () {
      setTimeout(updateTitle, 500);
    });

    updateTitle();
  });
});